import { render } from "./TheSearch.vue?vue&type=template&id=3b67d564&scoped=true"
import script from "./TheSearch.vue?vue&type=script&lang=js"
export * from "./TheSearch.vue?vue&type=script&lang=js"

import "./TheSearch.vue?vue&type=style&index=0&id=3b67d564&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b67d564"]])

export default __exports__